/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from "react";
import useAPIHandler from "../../../../hook/use-api-handler";

const useOrganizationLists = () => {
    const { fetchData, error, loading } = useAPIHandler();
    const [organizations, setOrganizations] = useState([]);
    const [pagination, setPagination] = useState({
        page: 1,
        pageSize: 2,
        total: 0,
        totalPages: 1,
    });

    const fetchOrganizations = async (page = 1, pageSize = 9) => {
        const URL = `/organization?page=${page}&pageSize=${pageSize}`;
        const METHOD = "GET";

        try {
            const result = await fetchData({
                url: URL,
                method: METHOD,
            });
         
            setOrganizations(result?.data?.organizations); 
            setPagination({
                page: result?.data?.pagination?.page || 1,
                pageSize: result?.data?.pagination?.pageSize || 2,
                total: result?.data?.pagination?.total || 0,
                totalPages: result?.data?.pagination?.totalPages || 1,
            });
        } catch (err) {
            console.error("Error fetching organizations:", err);
        }
    };

    const statusUpdate = async (orgId, status) =>{
        const URL = `/organization/admin/status/${orgId}`;
        const METHOD = "PUT";

        const payload = {
            url: URL,
            method: METHOD,
            data: {
                status
            }
        }
        try {
            const response = await fetchData(payload);
            if (response.status === 'success') {
                return response.data;
            }
            throw new Error('Status update failed');
            
        } catch (error) {
            console.error("Error status update organizations:", error);
            throw error;
        }
    }

    useEffect(() => {
        fetchOrganizations(); 
    }, []);

    return {
        organizations,
        loading,
        error,
        refetch:fetchOrganizations,
        statusUpdate,
        pagination
    };
};

export default useOrganizationLists;
